/**
 * @exports boolean condition to assess whether the site has the "What do you love" section
 */
export const HAS_WDYL = false

export const WDYL_CONFIG = {
  header: {
    default: {
      intro: 'Todo sobre',
      subtitle: 'Todos los detalles de este coche'
    },
    fallback: {
      intro: 'Todo lo que tenemos en',
      imgSrc: null
    }
  }
}
